import styles from './TitleBorder.module.scss';

export const TitleBorder = () => (
  <span className={styles.wrap}>
    <span className={styles['wrap-left']} />
  </span>
);
